import React from 'react';
import styled from 'styled-components';
import { ImageData } from '../Image';
import ListWithImage from '../ListModules/ListWithImage';
import PageOverlayStore from '../overlays/PageOverlays/PageOverlayStore';
import LegekammeratEntry from './LegekammeratEntry';
import LegekammeratOverlayContent from './LegekammeratOverlayContent';

const Container = styled.div<{ $bg?: string }>`
	background-color: ${props => props.$bg};
	width: 100%;
	padding: 0 var(--gridMargin);

	&:has(+ .BreakerModule) {
		padding-bottom: var(--breaker-total);
	}
`;

export default function Legekammerater(props: {
	data: {
		backgroundColorLink?: {
			color: string;
		};
		items: {
			image: ImageData;
			description: string;
			link: {
				url: string;
			}[];
			title: string;
		}[];
	};
}) {
	console.log(props);
	return (
		<Container $bg={props.data.backgroundColorLink?.color} className='colorWrapperAnimatedModule'>
			<ListWithImage>
				{props.data.items.map((item, index) => (
					<LegekammeratEntry
						key={'legekammerat_' + item.title + index}
						image={item.image}
						onClick={() =>
							PageOverlayStore.setContent(
								<LegekammeratOverlayContent
									description={item.description}
									link={item.link[0]}
									title={item.title}
								></LegekammeratOverlayContent>
							)
						}
					></LegekammeratEntry>
				))}
			</ListWithImage>
		</Container>
	);
}
